import React, { useEffect } from 'react'
import { Route, Switch, Redirect, useLocation } from 'react-router-dom'
import {
    Explore,
    Home,
    SearchResult,
    TextSearch,
    Saved,
    Recent,
    Shop,
    About,
    Business,
    BusinessPolicy,
    Infographic,
    MerchMaker
} from '../src/screens'
import Layout from './components/Layout'
import ReactGA from 'react-ga'

const App: React.FC<ServerData> = ({
    lang,
    textSearchResult,
    imageSearchResult
}) => {
    if (typeof window !== 'undefined' && window['GA_CODE']) {
        ReactGA.initialize(window['GA_CODE'])
    }
    useEffect(() => {
        const fonts = document.getElementById('webfonts')
        if (fonts) {
            fonts.removeAttribute('disabled')
        }
    })

    const { pathname, hash, key } = useLocation()
    useEffect(() => {
        // if not a hash link, scroll to top
        if (hash === '') {
            window.scrollTo(0, 0)
        } else {
            setTimeout(() => {
                const id = hash.replace('#', '')
                const element = document.getElementById(id)
                if (element) {
                    element.scrollIntoView()
                }
            }, 0)
        }
    }, [pathname, hash]) // do this on route change

    return (
        <Layout
            lang={lang}
            textSearchResult={textSearchResult}
            imageSearchResult={imageSearchResult}
        >
            <Switch>
                <Route exact={true} path="/" component={Home} />
                <Route
                    path="/search-result/"
                    key="/search-result/"
                    component={SearchResult}
                />
                <Route
                    path="/text-search/"
                    key="/text-search/"
                    component={TextSearch}
                />
                <Route path="/explore/" key="/explore/" component={Explore} />
                <Route path="/recent/" key="/recent/" component={Recent} />
                <Route path="/saved/" key="/saved/" component={Saved} />
                <Route path="/shop/:title" key="/shop/" component={Shop} />
                <Route path="/about/" key="/about/" component={About} />
                <Route
                    path="/merch-maker/"
                    key="/merch-maker/"
                    component={MerchMaker}
                />
                <Route
                    path="/policies/"
                    key="/policies/"
                    component={BusinessPolicy}
                />
                <Route
                    path="/infographic/"
                    key="/infographic/"
                    component={Infographic}
                />
                {/* redirect previous policy pages with new policy page */}
                <Route
                    path="/privacy/"
                    key="/privacy/"
                    render={(props) => <Redirect {...props} to="/policies" />}
                />
                <Route
                    path="/terms/"
                    key="/terms/"
                    render={(props) => <Redirect {...props} to="/policies" />}
                />
                <Route render={(props) => <Redirect {...props} to="/" />} />
            </Switch>
        </Layout>
    )
}

export default App
